import { Button, ButtonColors } from '@chiroup/components/Button';
import { OpenClosedStates } from '@chiroup/components/states';
import React, { useState } from 'react';
import MarketingCreateModal from './MarketingCreateModal';

type Props = {
  onCreate: () => void;
};

const MarketingCreate: React.FC<Props> = ({ onCreate }) => {
  const [state, setState] = useState<OpenClosedStates>(OpenClosedStates.Closed);

  const open = () => {
    setState(OpenClosedStates.Open);
  };

  const close = () => {
    setState(OpenClosedStates.Closed);
  };

  return (
    <>
      <MarketingCreateModal
        state={state}
        close={close}
        onCreate={onCreate}
        // lastName={lastName}
      />
      <Button
        text="Add"
        color={ButtonColors.plainWithBorder}
        className="cursor-pointer"
        onClick={open}
      />
    </>
  );
};

export default MarketingCreate;
